import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "language-body" }
const _hoisted_2 = { class: "language-content" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"white-space":"nowrap"} }

import { useLanguageStatusStore } from '@/store/LanguageStatusStore';
import { useLocaleStore } from '@/store/locale';


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageComponent',
  setup(__props) {

const localStore = useLocaleStore();
const languageStatusStore = useLanguageStatusStore();
/**
 * 选择语言
 * @param v 
 */
function SelectLanguage(v: DB.Language) {
    localStore.SetLocale(v.Code);
    languageStatusStore.show = false;
}

return (_ctx: any,_cache: any) => {
  const _component_VarIcon = _resolveComponent("VarIcon")!
  const _component_VarCard = _resolveComponent("VarCard")!

  return (_openBlock(), _createBlock(_component_VarCard, { lang: "Language" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(localStore).GetLanguageList, (v) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "language-item",
              onClick: ($event: any) => (SelectLanguage(v))
            }, [
              _createElementVNode("img", {
                class: "icon",
                src: v.Icon
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(v.Title), 1),
              _withDirectives(_createVNode(_component_VarIcon, {
                class: "l-action green",
                name: "gouxuan",
                namespace: "icon"
              }, null, 512), [
                [_vShow, _unref(localStore).GetLocale == v.Code]
              ])
            ], 8, _hoisted_3))
          }), 256))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})